import Button from "@mui/material/Button/Button";
import { useTranslation } from "react-i18next";

interface AppFooterProps {
  onNavClick?: (id: string) => void;
}

const AppFooter = ({ onNavClick }: AppFooterProps) => {
  const { t } = useTranslation();
  return (
    <footer className="layout-footer py-4 px-4 text-white">

      {/* Top Row */}
      <div className="flex justify-content-between align-items-center mt-6 mb-6">

        {/* Logo Left */}
        <div>
          <img
            src="/assets/layout/images/logo-6.png"
            alt="logo"
            style={{ width: "200px" }}
          />
        </div>

        {/* Social Icons Right */}
        <div className="flex flex-column align-items-end gap-2">

          {/* Icons Row */}
          <div className="flex gap-3">
            <a href="https://www.facebook.com/flexiroam/" target="_blank" rel="noopener noreferrer">
              <i className="pi pi-facebook text-2xl text-white"></i>
            </a>

            <a href="https://www.instagram.com/flexiroam/" target="_blank" rel="noopener noreferrer">
              <i className="pi pi-instagram text-2xl text-white"></i>
            </a>

            <a href="https://api.whatsapp.com/send/?phone=15558043874&text=Hi+I%27d+like+to+understand+how+you+can+help+on+my+connectivity+needs&type=phone_number&app_absent=0" target="_blank" rel="noopener noreferrer">
              <i className="pi pi-whatsapp text-2xl text-white"></i>
            </a>

          </div>

          {/* Email Row */}
          <a
            href="mailto:mastercard@flexiroam.com"
            className="text-white text-sm"
          >
            {t('footer.email')} : mastercard@flexiroam.com
          </a>

        </div>

      </div>

      {/* Divider */}
      <hr className="my-3 border-gray-500" />

      {/* Bottom Links */}
      <div className="flex flex-column lg:flex-row justify-content-center align-items-center gap-4 text-center mt-4 mb-6">

        <span className="font-medium">
          © 2026 {t('footer.copyright')}
        </span>

        <a
          href="https://www.flexiroam.com/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
          className="text-white font-medium underline"
        >
          {t('footer.privacy_policy')}
        </a>

        <a
          href="https://www.flexiroam.com/terms-and-conditions"
          target="_blank"
          rel="noopener noreferrer"
          className="text-white font-medium underline"
        >
          {t('footer.terms_of_service')}
        </a>

      </div>

    </footer>
  );
};

export default AppFooter;
